import React from 'react'
import {LOYALTY_STATUSES} from '../../helpers/misc'

const LEVEL_ORDER = ['AMBER', 'SILVER', 'GOLD', 'PLATINUM', 'LEGENDARY']

export function LoyaltyProgressBar({donationsCount}) {
  if (typeof donationsCount !== 'number')
    return null

  const levels = LEVEL_ORDER.map((key) => LOYALTY_STATUSES[key])
  const firstLevel = levels[0]
  const lastLevel = levels[levels.length - 1]

  // Reached the highest level, no further progress to show
  if (donationsCount >= lastLevel.from)
    return null

  const currentIndex = levels.findIndex((level) => donationsCount >= level.from && donationsCount <= level.to)

  // Below the first level (e.g. 0-9 donations): progress towards the first level
  const currentLevelFrom = currentIndex === -1 ? 0 : levels[currentIndex].from
  const nextLevelFrom = currentIndex === -1 ? firstLevel.from : levels[currentIndex + 1].from
  const remaining = nextLevelFrom - donationsCount

  const progress = Math.min(100, Math.round(((donationsCount - currentLevelFrom) / (nextLevelFrom - currentLevelFrom)) * 100))

  return (
    <div className="loyalty-progress-bar">
      <div className="loyalty-progress-bar-track">
        <div className="loyalty-progress-bar-fill" style={{width: `${progress}%`}}/>
      </div>
        <p className="loyalty-progress-bar-label mobile-only">
          Zbývá {remaining} darování do vyššího statusu
        </p>
        <p className="loyalty-progress-bar-label desktop-only">
          Zbývá {remaining} darování k postoupení do vyššího statusu
        </p>
    </div>
  )
}
